import { applyMiddleware, createStore } from "redux";
import reducer from './reducers/reducer';


//import RegisterPage from "./pages/RegisterPage/RegisterPage";
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';
import storage from 'redux-persist/lib/storage';
import promise from 'redux-promise-middleware';
import {thunk} from 'redux-thunk';
import { appMiddleware } from "./middlewares/app";
import { apiMiddleware } from "./middlewares/core";
 
const composeEnhancers = composeWithDevTools({
    trace: true,
    traceLimit: 25,
  });
  
  
  const persistConfig = {
    key: 'root',
    storage,
  };
  
  const createStoreWithMiddleware = composeEnhancers(window.location.port === "3000" ? applyMiddleware(
    appMiddleware,
    apiMiddleware,
    promise,
    thunk,
    // logger
  ) : applyMiddleware(
    appMiddleware,
    apiMiddleware,
    promise,
    thunk
  ))(createStore);
  
  
  const store = createStoreWithMiddleware(reducer);

  export default store;